import React from 'react'
import HrpGuideChat from '../chat/HrpGuideChat'
import HrpGuideChatV1 from '../chat/HrpGuideChatV1'

const HrpGuide = () => {
    return (
        <div className="home" style={{ padding: '1rem', display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'scroll' }}>
            <div style={{ borderBottom: '1px solid var(--lighterGrey)', paddingBottom: '1rem', }}>
                <p className="title">HealthRules Manager Agent</p>
                <p className="sub-title">The purpose of this agent is to provide you with information about the HealthRules Manager.</p>
            </div>

            <div style={{ display: 'flex', gap: '1rem', flex: 1, maxHeight: '100%', overflowY: 'scroll' }}>
                {/* <HrpGuideChat /> */}
                <HrpGuideChatV1 />

            </div>
        </div>
    )
}

export default HrpGuide